import { Check, ArrowRight } from "lucide-react";
import { PACKAGES, PACKAGE_LOOKUP } from "../content/site";
import { Reveal, SectionHeading } from "./Reveal";
import { PayButton } from "./PayButton";

export const Packages = () => (
  <section id="packages" data-testid="packages-section" className="relative py-24 lg:py-32 bg-white text-neutral-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading light align="center"
          overline="Website packages"
          title="Clear packages. Honest fixed prices."
          sub="Pay online to start immediately, or request a written quote first — either way you'll always know exactly what you're paying. No surprises."
        />
      </Reveal>
      <div className="mt-16 grid md:grid-cols-2 xl:grid-cols-4 gap-5 items-stretch">
        {PACKAGES.map((p, i) => (
          <Reveal key={p.id} delay={0.07 * i} className="h-full">
            <article
              data-testid={`package-card-${p.id}`}
              className={`relative h-full rounded-3xl p-7 flex flex-col transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 ${
                p.highlight
                  ? "bg-white border border-slate-200 border-t-2 !border-t-[#0055FF] shadow-[0_24px_64px_rgba(0,85,255,0.12)]"
                  : "bg-white border border-slate-200 soft-shadow hover:shadow-[0_16px_48px_rgba(2,6,23,0.08)] hover:border-slate-300"
              }`}
            >
              {p.highlight && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#0055FF] text-white text-[11px] font-semibold tracking-wide uppercase px-4 py-1.5 rounded-full glow-blue whitespace-nowrap">
                  Most Popular
                </span>
              )}
              <h3 className="font-display text-lg font-semibold tracking-tight text-slate-900">{p.name}</h3>
              <p className="mt-4 font-mono2 text-3xl font-semibold text-[#0055FF]">{p.price}</p>
              <p className="mt-3 text-sm leading-relaxed text-slate-500">{p.tagline}</p>
              <ul className="mt-6 space-y-2.5 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-slate-600">
                    <Check className="w-4 h-4 mt-0.5 shrink-0 text-[#0055FF]" />
                    {f}
                  </li>
                ))}
              </ul>
              {PACKAGE_LOOKUP[p.id] ? (
                <>
                  <PayButton lookupKey={PACKAGE_LOOKUP[p.id]} label={`Pay ${p.price.replace("From ", "")} — start`} testid={`package-pay-${p.id}`}
                    className={`mt-8 w-full ${
                      p.highlight
                        ? "bg-[#0055FF] hover:bg-[#0044CC] text-white glow-blue"
                        : "bg-slate-900 hover:bg-slate-700 text-white"
                    }`} />
                  <a href="#contact" data-testid={`package-cta-${p.id}`}
                    className="mt-3 text-center text-xs text-slate-400 hover:text-slate-600 transition-colors duration-200">
                    Prefer a written quote first?
                  </a>
                </>
              ) : (
                <a href="#contact" data-testid={`package-cta-${p.id}`}
                  className="mt-8 inline-flex items-center justify-center gap-2 font-semibold text-sm px-6 py-3 rounded-full transition-[background-color,color,border-color] duration-200 group border border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white">
                  {p.cta}
                  <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
                </a>
              )}
            </article>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15}>
        <p className="mt-10 text-center text-sm text-neutral-500">
          All three packages are fixed-price — pay online to start immediately, or request a written quote first. Larger projects are quoted individually.{" "}
          <a href="#calculator" data-testid="packages-calculator-link" className="text-[#0055FF] font-medium hover:underline">Try the instant estimate</a>.
        </p>
      </Reveal>
    </div>
  </section>
);
